/** core */
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ExtraOptions, NoPreloading, RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { ServiceWorkerModule } from '@angular/service-worker';

/** Conifg app */
import { CBModule } from "@core";
import { CBConfigModule } from "@core/services/config";
import { BxMockApiModule } from "@core/lib/mock-api";
import { CoreModule } from "app/configuration/core.module";
import { appConfig } from "app/configuration/config/app.config";
import { mockApiServices } from "app/mock-api";
import { LayoutModule } from "app/layout/layout.module";
import { AppComponent } from "app/app.component";
import { appRoutes } from "app/app.routing";


import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { ConnectionServiceModule } from 'ng-connection-service';

import { UtilsModule } from "@core/services/utils";
//globlal services
import { ErrorDialogService } from "@core/components/error-dialog/errordialog.service";
import { ApiModule } from "@core/services/api";

/** npm Modules */
import { ToastrModule } from 'ngx-toastr';

const routerConfig: ExtraOptions = {
  useHash: environment.useHash,
  scrollPositionRestoration: "enabled",
  preloadingStrategy: NoPreloading   // or PreloadAllModules    
};

/** Manage Geolocalzation */
import { GeolocalizationModule, geolocalizationService } from "@core/services/geolocalization";

/** custom Modules */
import { BlockUIModule } from "ng-block-ui";
import { BlockTemplateComponent } from "@core/components/block-template/block-template.component";
import { BxToastModule } from "@core/components/toast/toast.module";
import { BankProgressBarModule } from "@core/components/progress-bar";
import { environment } from "environments/environment";

/** Manage time Session */

import { ManageTimeSessionModule } from "@core/components/manage-time-session/manage-time-session.module";
import { ManageTimeSessionComponent } from "@core/components/manage-time-session/manage-time-session.component";
import { ManageTimeService } from "@core/components/manage-time-session/manage-time-session.service";


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    BxToastModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),

    UtilsModule,
    // cb, BxConfig & BxMockAPI
    CBModule,
    CBConfigModule.forRoot(appConfig),
    BxMockApiModule.forRoot(mockApiServices),

    // Detects whether browser has an active internet connection or not in application.
    ConnectionServiceModule,

    // manage time session
    ManageTimeSessionModule,

    // add manage session
    NgIdleKeepaliveModule.forRoot(),

    // Core module of your application
    CoreModule,

    // Layout module of your application
    LayoutModule,
    // show progress bar
    BankProgressBarModule,

    // manage geolocalization
    GeolocalizationModule,

    // manage block 
    BlockUIModule.forRoot({
      template: BlockTemplateComponent
    }),
    // Toastr Module
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      timeOut: 3000,
      preventDuplicates: false,
      progressBar: true,
      closeButton: true,
      tapToDismiss: false,
    }),

    ApiModule,

    // Service Worker
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.serviceWorker.enabled,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  entryComponents: [ManageTimeSessionComponent],
  providers: [ManageTimeService,
    ErrorDialogService,
    // { provide: APP_INITIALIZER, useFactory: (geo: geolocalizationService) => function () { return geo.handlePermission(); }, deps: [geolocalizationService], multi: true },

  ],

  bootstrap: [AppComponent],
})
export class AppModule { }
